<template>
  <div>
    <v-snackbar
      :timeout="4500"
      elevation="20"
      transition="scale-transition"
      right
      top
      :color="notificationType"
      v-model="snackbar"
      class="white--text body-2"
    >
      {{ notification.message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
    // snackbar: {
    //   type: Boolean,
    //   required: true,
    // },
  },
  data() {
    return {
      timeout: null,
      snackbar: true,
    };
  },
  mounted() {
    this.timeout = setTimeout(() => {
      this.remove(this.notification);
    }, 4500);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  computed: {
    notificationType() {
      if (this.notification.type == "success") {
        return "green accent-3";
      } else if (this.notification.type == "info") {
        return "yellow darken-3";
      } else {
        return "error";
      }
    },
  },
  methods: mapActions("notification", ["remove"]),
};
</script>

<style scoped></style>
